package tta.destinigo.talktoastro.feature_call_consultation.data.request

enum class VoIPCallStatus(val status: String) {
    END("End"),
    IN_PROGRESS("in-progress")
}